// Copyright (c) 2016 Deere & Company

import Branches, {getDefaultState} from '../state/branches';
import actions from '../../actions-list';

const updateDemoRentalBranch = (state, action) =>
    Branches.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_DEMO_RENTAL_BRANCH_SUCCESS]: updateDemoRentalBranch
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/reducers/branches.js